export const formatControlDate = (value, locale = 'en') => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat(locale.replace('_', '-'), {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};
